function initLandingChrome() {
  'use strict';

  function initRangeMenu() {
    document.querySelectorAll('[data-range-menu]').forEach(function(root,index) {
    if (root.dataset.ffInitialized) return;
    root.dataset.ffInitialized='true';
    var toggle = root.querySelector('[data-range-toggle]');
    var panel = root.querySelector('[data-range-panel]');
    if (!toggle || !panel) return;
    panel.id='ff-range-panel-'+index;toggle.setAttribute('aria-controls',panel.id);
    var desktop = window.matchMedia('(min-width: 768px)');
    var hover = window.matchMedia('(hover: hover)');
    var closeTimer;

    function setOpen(open) {
      window.clearTimeout(closeTimer);
      open = !!open;
      panel.hidden = !open;
      panel.inert = !open;
      root.toggleAttribute('data-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }

    setOpen(false);
    toggle.disabled = false;
    toggle.addEventListener('click', function (event) {
      setOpen(desktop.matches && event.detail && hover.matches ? true : panel.hidden);
    });
    root.addEventListener('mouseenter', function () {
      if (desktop.matches && hover.matches) setOpen(true);
    });
    root.addEventListener('mouseleave', function () {
      if (desktop.matches && !root.contains(document.activeElement)) {
        closeTimer = window.setTimeout(function () {
          if (!root.contains(document.activeElement) && !root.matches(':hover')) setOpen(false);
        }, 150);
      }
    });
    root.addEventListener('focusout', function () {
      queueMicrotask(function () {
        if (desktop.matches && !root.contains(document.activeElement) && !(hover.matches && root.matches(':hover'))) setOpen(false);
      });
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault();
        setOpen(false);
        toggle.focus();
      }
      if (event.target === toggle && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault();
        setOpen(true);
        var links = panel.querySelectorAll('a');
        var link = event.key === 'ArrowDown' ? links[0] : links[links.length - 1];
        if (link) link.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) setOpen(false);
    });
    desktop.addEventListener('change', function () {setOpen(false);});
    });
  }

  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu || menu.dataset.ffInitialized) return;
    menu.dataset.ffInitialized='true';
    var desktop = window.matchMedia('(min-width: 768px)');
    var isDialog = typeof menu.showModal === 'function';
    var close = menu.querySelector('[data-menu-close]');

    function isOpen() { return isDialog ? menu.open : !menu.hidden; }

    function setOpen(open, returnFocus) {
      var page = document.documentElement;
      var opening = open && !isOpen();
      var pageWidth = opening ? page.getBoundingClientRect().width : 0;
      if (isDialog) {
        menu.hidden = false;
        if (open && !menu.open) {
          menu.showModal();
          if (close) close.focus({ preventScroll: true });
        }
        if (!open && menu.open) menu.close();
      } else {
        menu.hidden = !open;
        menu.toggleAttribute('open', open);
      }
      document.body.classList.toggle('ff-menu-open', open);
      page.classList.toggle('ff-menu-open', open);
      if (opening) page.style.setProperty('--ff-scrollbar-width', Math.max(0, page.getBoundingClientRect().width - pageWidth) + 'px');
      if (!open) page.style.removeProperty('--ff-scrollbar-width');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      toggle.setAttribute('title', open ? 'Close menu' : 'Open menu');
      if (returnFocus) toggle.focus({ preventScroll: true });
    }

    setOpen(false);
    toggle.addEventListener('click', function () {
      setOpen(!isOpen());
    });
    if (close) close.addEventListener('click', function () { setOpen(false, true); });
    menu.addEventListener('cancel', function (event) { event.preventDefault(); setOpen(false, true); });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
      if (event.target === menu) {
        var rect = menu.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) setOpen(false, true);
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) setOpen(false, true);
      if (event.key === 'Tab' && isOpen()) {
        var links = Array.from(menu.querySelectorAll('a[href], button:not(:disabled), summary')).filter(function (link) {
          return link.getClientRects().length > 0 && (link.matches('summary') || !link.closest('details:not([open])'));
        });
        var first = links[0];
        var last = links[links.length - 1];
        var outside = !menu.contains(document.activeElement);
        if (event.shiftKey && (document.activeElement === first || outside)) {
          event.preventDefault();
          if (last) last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || outside)) {
          event.preventDefault();
          if (first) first.focus();
        }
      }
    });
    desktop.addEventListener('change', function () {
      if (desktop.matches) setOpen(false);
    });
    toggle.hidden = false;
  }

  function initMarquee() {
    var root = document.querySelector('[data-marquee]');
    if (!root || root.dataset.ffInitialized) return;
    root.dataset.ffInitialized='true';
    var text = root.querySelector('[data-marquee-text]');
    var track = root.querySelector('[data-marquee-track]');
    var phrase = root.querySelector('[data-marquee-phrase]');
    var fallback = root.querySelector('[data-marquee-static]');
    var animated = root.querySelector('[data-marquee-animated]');
    if (!text || !track || !phrase || !fallback || !animated) return;
    var svg = text.ownerSVGElement;
    var href = track.getAttribute('href') || track.getAttribute('xlink:href');
    var path = href && document.getElementById(href.split('#').pop());
    if (!svg || !path || typeof path.getTotalLength !== 'function') return;

    var desktop = window.matchMedia('(min-width: 768px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var phraseWidth = 0;
    var phase = 0;
    var frame = null;
    var lastTime = null;
    var inView = true;
    var ready = false;
    var fontsReady = false;
    var initialOffset = track.getAttribute('startOffset') || '0';

    function stop() {
      if (frame !== null) window.cancelAnimationFrame(frame);
      frame = null;
      lastTime = null;
    }

    function canAnimate() {
      return desktop.matches && ready && !reducedMotion.matches && !document.hidden && inView;
    }

    function tick(time) {
      frame = null;
      if (!canAnimate()) {
        lastTime = null;
        return;
      }
      if (lastTime !== null) phase = (phase + (time - lastTime) * 0.06) % phraseWidth;
      lastTime = time;
      track.setAttribute('startOffset', String(-phase));
      frame = window.requestAnimationFrame(tick);
    }

    function sync() {
      var dynamic = desktop.matches && ready && !reducedMotion.matches;
      animated.hidden = !dynamic;
      fallback.hidden = dynamic;
      if (canAnimate()) {
        if (frame === null) frame = window.requestAnimationFrame(tick);
      } else {
        stop();
      }
    }

    function measure() {
      if (!desktop.matches || !fontsReady) {
        sync();
        return;
      }
      animated.hidden = false;
      var width;
      var pathLength;
      try {
        width = phrase.getComputedTextLength();
        pathLength = path.getTotalLength();
      } catch (error) {
        ready = false;
        sync();
        return;
      }
      if (!(width > 0) || !(pathLength > 0)) {
        ready = false;
        sync();
        return;
      }

      if (phraseWidth) {
        phase = phase / phraseWidth * width;
      } else {
        var offset = parseFloat(initialOffset) || 0;
        if (initialOffset.indexOf('%') !== -1) offset = offset / 100 * pathLength;
        phase = ((width - offset) % width + width) % width;
      }
      phraseWidth = width;
      var repeats = Math.ceil(pathLength / width) + 3;
      var content = document.createDocumentFragment();
      for (var index = 0; index < repeats; index += 1) {
        phrase.childNodes.forEach(function (child) {
          content.appendChild(child.cloneNode(true));
        });
      }
      track.replaceChildren(content);
      track.setAttribute('startOffset', String(-phase));
      ready = true;
      sync();
    }

    desktop.addEventListener('change', measure);
    reducedMotion.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('resize', measure);
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        sync();
      });
      observer.observe(root);
    }
    sync();
    var fonts = document.fonts ? document.fonts.ready : Promise.resolve();
    fonts.then(function () {
      fontsReady = true;
      measure();
    });
  }

  initRangeMenu();
  initMenu();
  initMarquee();
}
initLandingChrome();
document.addEventListener('shopify:section:load',initLandingChrome);
function initCompetition() {
 'use strict';
 var base=(document.body.dataset.campaignApi||'').replace(/\/$/,'');
 var form=document.querySelector('[data-entry-form]'),delivery=document.querySelector('[data-delivery-form]');
 var details=form&&form.closest('article'),registration=document.querySelector('[data-registration]');
 var success=document.querySelector('[data-success]');
 var winner=document.querySelector('[data-winner-announcement]');
 var input=document.querySelector('[data-suburb]');
 var status=document.querySelector('[data-delivery-status]');
 var entryWindow=null;try{entryWindow=JSON.parse(document.querySelector('[data-campaign-window]').textContent);}catch(_){}
 var config=null,areas=[],postcode=null,selectedArea=null,verifiedArea=null,revision=0,loading=false,saving=false,requestId=null,requestPayload=null;
 var errors={suburb_required:'This postcode covers multiple states. Please select your suburb from the list.',duplicate_email:'This email has already entered the competition.',competition_closed:'Entries are currently closed.',outside_delivery_area:'Sorry, we don’t deliver in your area yet, so unfortunately you can’t enter the competition.',rate_limited:'Too many attempts. Please wait a minute and try again.',invalid_fields:'Please check your details and try again.'};
 function windowOpen(value){
  function time(text){return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(text||'')?Date.parse(text.replace(' ','T')+':00+10:00'):NaN;}
  var start=time(value&&value.startsAt),end=time(value&&value.endsAt),now=Date.now();
  return !!value&&value.enabled===true&&Number.isFinite(start)&&Number.isFinite(end)&&start<end&&now>=start&&now<end;
 }
 async function freshWindow(){
  var url=new URL(location.href);url.hash='';url.searchParams.set('section_id',entryWindow.sectionId);url.searchParams.set('_campaign_window',String(Date.now()));
  var r=await fetch(url.href,{cache:'no-store',credentials:'same-origin',signal:AbortSignal.timeout(15000)});if(!r.ok)throw new Error('We couldn’t check the entry dates. Please try again.');
  var node=new DOMParser().parseFromString(await r.text(),'text/html').querySelector('[data-campaign-window]');if(!node)throw new Error('We couldn’t check the entry dates. Please try again.');
  return JSON.parse(node.textContent);
 }
 function notice(node,message){node.textContent=message;node.hidden=false;}
 function busy(button,value,label){button.disabled=value;button.setAttribute('aria-busy',String(value));button.textContent=value?'Please wait…':label;}
 async function api(path,body){
  var response=await fetch(base+'/api/win-free-food/'+path,{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined,credentials:'omit',signal:AbortSignal.timeout(20000)});
  var data=await response.json();if(!response.ok){var e=new Error(errors[data.error]||'We couldn’t complete this right now. Please try again.');e.code=data.error;e.fields=data.fields;throw e;}return data;
 }
 function announce(c){if(!winner||!c.announcementDate)return;var date=new Date(c.announcementDate+'T12:00:00+10:00');var formatted=date.toLocaleDateString('en-AU',{day:'numeric',month:'long',year:'numeric',timeZone:'Australia/Brisbane'});var template=winner.dataset.announcementTemplate||'Thank you for entering our giveaway. We’ll announce the winner on {winner_date} so keep an eye on your inbox!';winner.innerHTML=template;var walker=document.createTreeWalker(winner,NodeFilter.SHOW_TEXT);var text;while((text=walker.nextNode())){text.nodeValue=text.nodeValue.split('{winner_date}').join(formatted);}}
 if(!form||!delivery||!input||!base||form.dataset.ffInitialized)return;
 form.dataset.ffInitialized='true';
 if(details)details.hidden=true;
 document.body.dataset.state='entry';
 var check=delivery.querySelector('[type="submit"]'),submit=form.querySelector('[type="submit"]');
 var availability=document.querySelector('[data-entry-availability]');availability.addEventListener('cancel',function(event){event.preventDefault();});
 // Keep the notice outside inert content and below the interactive header.
 document.body.appendChild(availability);
 var campaignBackground=document.querySelectorAll('#main-content,.wff-section--footer');
 var error=document.createElement('p');error.className='ff-delivery-status';error.setAttribute('role','alert');error.hidden=true;form.appendChild(error);
 var field=delivery.querySelector('[data-suburb-field]'),list=delivery.querySelector('[data-suburb-suggestions]'),validated=delivery.querySelector('[data-suburb-check]');
 var matches=[],activeIndex=-1,pendingSelection=false;
 function hideSuggestions(){list.hidden=true;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');activeIndex=-1;list.querySelectorAll('[role="option"]').forEach(function(row){row.classList.remove('is-active');row.setAttribute('aria-selected','false');});}
 function renderSuggestions(){
  var query=input.value.trim().toLowerCase(),numeric=/^\d{1,4}$/.test(query),seen=new Set();
  matches=areas.filter(function(area){var key=area.label.toLowerCase();if(!query||seen.has(key))return false;seen.add(key);return numeric?area.postcode.indexOf(query)===0:area.suburb.toLowerCase().indexOf(query)!==-1;}).slice(0,8);
  hideSuggestions();list.replaceChildren();
  if(!matches.length||input.disabled||document.activeElement!==input)return;
  matches.forEach(function(area,index){
   var row=document.createElement('li'),name=document.createElement('span'),meta=document.createElement('span');
   row.id=list.id+'-'+index;row.className='ff-suburb-suggestion';row.setAttribute('role','option');row.setAttribute('aria-selected','false');
   name.textContent=area.suburb+(area.state?', '+area.state:'');meta.className='ff-suburb-suggestion__meta';meta.textContent=area.postcode;row.append(name,meta);
   row.addEventListener('mousedown',function(event){event.preventDefault();});
   row.addEventListener('click',function(){selectSuggestion(area);});list.appendChild(row);
  });
  list.hidden=false;input.setAttribute('aria-expanded','true');
 }
 function selectSuggestion(area){input.value=area.label;reset();selectedArea=area;hideSuggestions();input.focus({preventScroll:true});hideSuggestions();if(loading)pendingSelection=true;else delivery.requestSubmit();}
 function activateSuggestion(index){activeIndex=index;var rows=list.querySelectorAll('[role="option"]');rows.forEach(function(row,i){row.classList.toggle('is-active',i===index);row.setAttribute('aria-selected',String(i===index));});input.setAttribute('aria-activedescendant',rows[index].id);rows[index].scrollIntoView({block:'nearest'});}
 input.addEventListener('focus',renderSuggestions);
 input.addEventListener('blur',function(event){if(!field.contains(event.relatedTarget))hideSuggestions();});
 input.addEventListener('keydown',function(event){
  if(event.isComposing)return;
  if(event.key==='Escape'){if(!list.hidden)event.preventDefault();hideSuggestions();return;}
  if(event.key==='Tab'){hideSuggestions();return;}
  if(event.key==='ArrowDown'||event.key==='ArrowUp'){
   if(list.hidden)renderSuggestions();if(!matches.length||list.hidden)return;event.preventDefault();
   var next=activeIndex<0?(event.key==='ArrowDown'?0:matches.length-1):(activeIndex+(event.key==='ArrowDown'?1:-1)+matches.length)%matches.length;
   activateSuggestion(next);
  }else if(event.key==='Enter'&&!list.hidden&&activeIndex>=0){event.preventDefault();selectSuggestion(matches[activeIndex]);}
 });
 function sync(){var open=windowOpen(entryWindow);input.disabled=saving||!open;check.disabled=loading||saving||!open;submit.disabled=saving||!postcode||!open;if(input.disabled)hideSuggestions();document.body.toggleAttribute('data-competition-closed',!open);campaignBackground.forEach(function(node){node.inert=!open;});if(open){if(availability.open)availability.close();availability.hidden=true;}else{availability.hidden=false;if(!availability.open){availability.show();availability.querySelector('h3').focus({preventScroll:true});}details.hidden=true;status.hidden=true;}}
 var entryInputs=Array.from(form.querySelectorAll('.ff-fields input'));
 function fieldMessage(field){
  var value=field.value.trim();if(!value)return 'This field is required.';
  if(field.name==='email'&&(!field.validity.valid||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)))return 'Enter a valid email address.';
  if(field.name==='phone'&&(!/^\+?[0-9 ()-]{8,40}$/.test(value)||value.replace(/\D/g,'').length<8||value.replace(/\D/g,'').length>15))return 'Enter a valid phone number.';
  if(!field.validity.valid)return 'Please check this field.';return '';
 }
 function showFieldError(field,message){field.setAttribute('aria-invalid',message?'true':'false');var node=form.querySelector('[data-field-error="'+field.name+'"]');node.textContent=message;node.hidden=!message;}
 function validateFields(){var first=null;entryInputs.forEach(function(field){var message=fieldMessage(field);showFieldError(field,message);if(message&&!first)first=field;});if(first)first.focus();return !first;}
 entryInputs.forEach(function(field){field.addEventListener('blur',function(){showFieldError(field,fieldMessage(field));});field.addEventListener('input',function(){if(field.getAttribute('aria-invalid')==='true')showFieldError(field,fieldMessage(field));error.hidden=true;});});
 function reset(){revision++;pendingSelection=false;postcode=null;selectedArea=null;verifiedArea=null;details.hidden=true;status.hidden=true;error.hidden=true;input.removeAttribute('aria-invalid');field.classList.remove('ff-suburb-field--validated','ff-suburb-field--error');validated.setAttribute('hidden','');entryInputs.forEach(function(field){showFieldError(field,'');});sync();}
 input.addEventListener('input',function(){reset();renderSuggestions();});form.addEventListener('input',sync);form.addEventListener('change',sync);
 delivery.addEventListener('submit',async function(event){
  event.preventDefault();if(loading||saving||!windowOpen(entryWindow)){sync();return;}
  var value=input.value.trim(),match=areas.find(function(a){return a.label.toLowerCase()===value.toLowerCase();});
  var code=/^\d{4}$/.test(value)?value:match&&match.postcode;
  if(!code){input.setAttribute('aria-invalid','true');field.classList.add('ff-suburb-field--error');notice(status,'Enter a four-digit postcode or choose a suburb from the list.');input.focus();return;}
  var selection=selectedArea&&selectedArea.label===value?selectedArea:null;
  reset();selectedArea=selection;hideSuggestions();var run=revision;loading=true;busy(check,true,'Check');
  try{var data=await api('check',{postcode:code,...(selection?{suburb:selection.suburb,state:selection.state}:{})});if(run!==revision)return;config=data;announce(data);
   if(data.eligible){postcode=code;verifiedArea=selection;field.classList.add('ff-suburb-field--validated');validated.removeAttribute('hidden');notice(status,'Looks good!');details.hidden=false;sync();}
   else{input.setAttribute('aria-invalid','true');field.classList.add('ff-suburb-field--error');notice(status,errors.outside_delivery_area+' Stay in touch and follow us on Instagram: ');var link=document.createElement('a');link.href=data.instagramUrl;link.textContent='Follow @funkyfoodau';status.appendChild(link);}
  }catch(e){if(run===revision){notice(status,e.message);if(e.code==='suburb_required'){input.setAttribute('aria-invalid','true');field.classList.add('ff-suburb-field--error');input.focus({preventScroll:true});renderSuggestions();}}}finally{loading=false;busy(check,false,'Check');sync();if(pendingSelection){pendingSelection=false;delivery.requestSubmit();}}
 });
 form.addEventListener('submit',async function(event){
  event.preventDefault();if(!windowOpen(entryWindow)){sync();return;}if(saving||!postcode)return;if(!validateFields())return;
  var fields=new FormData(form);var payload={firstName:fields.get('firstName'),lastName:fields.get('lastName'),phone:fields.get('phone'),email:fields.get('email'),instagram:fields.get('instagram'),marketing:true,postcode:postcode,...(verifiedArea?{suburb:verifiedArea.suburb,state:verifiedArea.state}:{})};
  var identity=JSON.stringify(payload);if(identity!==requestPayload){requestPayload=identity;requestId=crypto.randomUUID();}payload.requestId=requestId;
  saving=true;error.hidden=true;busy(submit,true,'Submit');check.disabled=true;input.disabled=true;
  try{entryWindow=await freshWindow();if(!windowOpen(entryWindow)){saving=false;input.disabled=false;check.disabled=false;busy(submit,false,'Submit');sync();return;}var result=await api('entries',payload);
   announce(result);registration.hidden=true;success.hidden=false;document.body.dataset.state='success';
   // Analytics must never interrupt a successfully saved entry.
   try{if(typeof window.fbq==='function')window.fbq('trackCustom','FreeFoodEntry');}catch(_){}
   busy(submit,false,'Submit');submit.disabled=true;
   var heading=success.querySelector('h2');
   if(heading){heading.focus({preventScroll:true});heading.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  }catch(e){
   var firstInvalid=null;
   if(e.code==='duplicate_email'){showFieldError(form.elements.email,e.message);firstInvalid=form.elements.email;}
   else if(e.code==='invalid_fields'&&Array.isArray(e.fields)){e.fields.forEach(function(name){var field=form.elements[name];if(field&&field.matches('.ff-fields input')){showFieldError(field,fieldMessage(field)||'Please check this field.');if(!firstInvalid)firstInvalid=field;}});}
   if(firstInvalid){error.hidden=true;firstInvalid.focus();}else notice(error,e.message);
   saving=false;input.disabled=false;check.disabled=false;busy(submit,false,'Submit');sync();
  }
 });
 // Both postcode checking and entry submission follow the Shopify campaign window.
 busy(check,false,'Check');sync();
 api('config').then(function(data){if(!config)config=data;announce(config);sync();}).catch(function(){});
 api('areas').then(function(data){
  areas=data.areas.map(function(a){return {suburb:a.suburb,state:a.state,postcode:a.postcode,label:a.suburb+', '+a.state+' '+a.postcode};});
  renderSuggestions();
 }).catch(function(){/* A four-digit postcode can still be checked without suggestions. */});
}
initCompetition();
document.addEventListener('shopify:section:load',initCompetition);
